define('plugin/package/collection/PackageCollection',['require','lib/collection/ServerPaginatedCollection','plugin/package/model/PackageInstanceModel'],function (require) {

    var Parent = require('lib/collection/ServerPaginatedCollection');
    var PackageInstanceModel = require('plugin/package/model/PackageInstanceModel');

    /**
     * Client package instance collection
     *
     * @class PackageInstanceCollection
     */
    return Parent.extend({

        url: '/ext/package/',
        model: PackageInstanceModel

    });

});
